<template>
  <div class="container">
    <titular />
    <ul class="list-inline">
      <li class="list-inline-item">
        <modal ref="modalCreacionMultiple" titulo="Afegir dedicacions" icono="fa-solid fa-list-check" :loading="loading.creacionMultiple" @abrir="abrirModal('autofocusCreacionMultiple')" @cerrar="cerrarCreacion">
          <template v-slot:body>
            <form id="form-creacion-multiple" autocomplete="off" @submit.prevent="crearMultiple">
              <div class="form-group w-50">
                <label for="nuevo-data_dedicacio">Data</label>
                <input ref="autofocusCreacionMultiple" type="date" class="form-control" id="nuevo-data_dedicacio" v-model="nuevos.dedicacion.data_dedicacio" :disabled="loading.creacionMultiple" :min="minFecha" :max="maxFecha" required />
              </div>
              <div class="form-group">
                <label for="nuevo-trabajador">Treballador</label>
                <select class="form-control" id="nuevo-trabajador" v-model="nuevos.dedicacion.id_treballador" :disabled="loading.creacionMultiple" required>
                  <option v-for="(trabajador, index) in trabajadores" :key="index" :value="trabajador.id">{{ trabajador.nombre_completo }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="nuevo-proyecto">Projecte</label>
                <select class="form-control" id="nuevo-proyecto" v-model="nuevos.dedicacion.id_projecte" :disabled="loading.creacionMultiple" required>
                  <option v-for="(proyecto, index) in proyectos" :key="index" :value="proyecto.id">{{ proyecto.cliente }} → {{ proyecto.titol }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="nuevo-temps">Hores</label>
                <div class="input-group w-50">
                  <input type="number" step="0.25" class="form-control" id="nuevo-temps" v-model="nuevos.dedicacion.temps" :disabled="loading.creacionMultiple" min="0.25" required />
                </div>
              </div>
              <div class="form-group">
                <label for="nuevo-observacions">Observacions</label>
                <textarea class="form-control" id="nuevo-observacions" rows="2" v-model="nuevos.dedicacion.observacions" :disabled="loading.creacionMultiple"></textarea>
              </div>
            </form>
          </template>
          <template v-slot:footer>
            <button type="submit" class="btn btn-primary" form="form-creacion-multiple" :disabled="loading.creacionMultiple"><i-submit icono="fa-list-check" :loading="loading.creacionMultiple" />Continuar</button>
          </template>
        </modal>
      </li>
    </ul>
    <div class="row mb-5">
      <div class="col">
        <rangofechas tipoRango="LM" :rangoMax="rangoMax" :tiposRango="['tot', 'LTM', 'YTD', 'LM']" @buscar="getData" @reiniciarForm="cliente = ''">
          <div class="cliente input-group mb-2 mr-sm-2 ml-sm-2">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fas fa-user-tie" title="Client" v-tooltip></i></div>
            </div>
            <select class="custom-select" v-model="cliente" :disabled="loading.clientes">
              <option value="" class="font-weight-bold">Client</option>
              <option v-for="(cliente, index) in clientes" :key="index" :value="cliente.id">{{ cliente.titol }}</option>
            </select>
          </div>
        </rangofechas>
      </div>
    </div>
    <vue-bootstrap4-table id="tabla" ref="tabla" :rows="rows" :columns="columns" :classes="classes" :config="config" :actions="actionsExportar" @exportarTabla="exportarTablaPrevio" @exportarBolcat="exportarBolcatPrevio">
      <template slot="empty-results">No hi ha cap dedicació</template>
      <template slot="global-search-clear-icon">
        <i class="fa-solid fa-circle-xmark"></i>
      </template>
      <template slot="sort-asc-icon">
        <i class="fa-solid fa-sort-up"></i>
      </template>
      <template slot="sort-desc-icon">
        <i class="fa-solid fa-sort-down"></i>
      </template>
      <template slot="no-sort-icon">
        <i class="fas fa-sort"></i>
      </template>
      <template slot="simple-filter-clear-icon">
        <i class="fa-solid fa-circle-xmark"></i>
      </template>
      <template slot="paginataion-previous-button">
        <i class="fa-solid fa-angle-left"></i>
      </template>
      <template slot="paginataion-next-button">
        <i class="fa-solid fa-angle-right"></i>
      </template>
      <template v-slot:pagination-info="props">
        Registres: {{ props.currentPageRowsLength }} de {{ props.filteredRowsLength }}<template v-if="props.filteredRowsLength !== props.originalRowsLength"> ({{ props.originalRowsLength }} en total)</template>
      </template>
      <template slot="selected-rows-info" slot-scope="props">{{ props }} Selecció: {{ props.selectedItemsCount }}</template>
      <template slot="acciones" slot-scope="props">
        <div class="btn-group btn-group-sm" role="group" aria-label="Accions">
          <button class="btn btn-secondary" data-toggle="modal" :data-target="`#modal-editar-${props.row.id}`" title="Editar dedicació" v-tooltip><i class="fa-solid fa-pen-to-square"></i></button>
          <button class="btn btn-secondary" data-toggle="modal" :data-target="`#modal-eliminar-${props.row.id}`" title="Eliminar dedicació" v-tooltip><i class="fa-solid fa-trash-can"></i></button>
        </div>
        <div class="text-left">
          <modal :ref="`modalEdicion${props.row.id}`" titulo="Editar dedicació" icono="fa-solid fa-pen-to-square" btnClass="btn-secondary" :hayLanzador="false" :modalId="`editar-${props.row.id}`" :loading="loading.edicion" @abrir="abrirModal(`autofocusEdicion${props.row.id}`)" @cerrar="cerrarEdicion">
            <template v-slot:body>
              <form :id="`form-edicion${props.row.id}`" autocomplete="off" @submit.prevent="editar(props.row.id)">
                <div class="form-group">
                  <label :for="`data_dedicacio${props.row.id}`">Data</label>
                  <input :ref="`autofocusEdicion${props.row.id}`" type="date" class="form-control" :id="`data_dedicacio${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).data_dedicacio" :disabled="loading.edicion" :min="getMinFecha(getRowId(props.row.id, rows).data_dedicacio)" :max="maxFecha" required />
                </div>
                <div class="form-group">
                  <label :for="`trabajador${props.row.id}`">Treballador</label>
                  <select class="form-control" :id="`trabajador${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).id_treballador" :disabled="loading.edicion" required>
                    <option v-for="(trabajador, index) in trabajadores" :key="index" :value="trabajador.id">{{ trabajador.nombre_completo }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label :for="`proyecto${props.row.id}`">Projecte</label>
                  <select class="form-control" :id="`proyecto${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).id_projecte" :disabled="loading.edicion" required>
                    <option v-for="(proyecto, index) in proyectos" :key="index" :value="proyecto.id">{{ proyecto.cliente }} → {{ proyecto.titol }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label :for="`temps${props.row.id}`">Hores</label>
                  <input type="number" step="0.25" class="form-control" :id="`temps${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).temps" :disabled="loading.edicion" min="0.25" required />
                </div>
                <div class="form-group">
                  <label :for="`observacions${props.row.id}`">Observacions</label>
                  <textarea class="form-control" :id="`observacions${props.row.id}`" rows="2" v-model="getRowId(props.row.id, rowsBuffer).observacions" :disabled="loading.edicion"></textarea>
                </div>
              </form>
            </template>
            <template v-slot:footer>
              <button type="submit" class="btn btn-primary" :disabled="loading.edicion" :form="`form-edicion${props.row.id}`"><i-submit icono="fa-pen-to-square" :loading="loading.edicion" />Confirmar</button>
            </template>
          </modal>
          <modal :ref="`modalEliminacion${props.row.id}`" titulo="Eliminar dedicació" icono="fa-solid fa-trash-can" btnClass="btn-secondary" :hayLanzador="false" :modalId="`eliminar-${props.row.id}`" :loading="loading.eliminacion" @abrir="abrirModal(`autofocusEliminacion${props.row.id}`)" @cerrar="cerrarEliminacion">
            <template v-slot:body>
              <div class="alert alert-warning" role="alert"><i class="fa-solid fa-triangle-exclamation mr-1"></i>Aquesta acció no es pot desfer.</div>
              Vols eliminar la dedicació #<b>{{ props.row.id }}</b>?
            </template>
            <template v-slot:footer>
              <button :ref="`autofocusEliminacion${props.row.id}`" type="submit" class="btn btn-danger" :disabled="loading.eliminacion" @click="eliminar(props.row.id)"><i-submit icono="fa-trash-can" :loading="loading.eliminacion" />Confirmar</button>
            </template>
          </modal>
        </div>
      </template>
      <template slot="data_dedicacio_cell" slot-scope="props">
        {{ props.row.data_dedicacio_format }}
      </template>
      <template slot="temps" slot-scope="props"> {{ parseFloat(props.cell_value).toLocaleString(undefined, { maximumFractionDigits: 2 }) }} </template>
    </vue-bootstrap4-table>
  </div>
</template>

<style lang="scss">
#tabla {
  .vbt-refresh-button {
    display: none;
  }
}

@media (min-width: 768px) {
  .cliente {
    max-width: 225px;
  }
}
</style>

<script>
import rangofechas from "@/components/RangoFechas.vue"

export default {
  name: "Dedicacions",
  inject: ["exportarTabla", "exportarBolcat", "actionsExportar", "formatearFecha"],
  components: {
    rangofechas,
  },
  data() {
    return {
      loading: {
        creacion: false,
        edicion: false,
        eliminacion: false,
        creacionMultiple: false,
        clientes: false,
      },
      rows: [],
      rowsBuffer: [],
      columns: [
        {
          label: "#",
          name: "id",
          filter: {
            type: "simple",
            placeholder: "Filtra ID",
          },
          sort: true,
          initial_sort: true,
          initial_sort_order: "desc",
          row_text_alignment: "text-left",
        },
        {
          label: "Data",
          name: "data_dedicacio_cell",
          filter: {
            type: "simple",
            placeholder: "Filtra data",
          },
          sort: true,
          row_text_alignment: "text-center",
        },
        {
          label: "Hores",
          name: "temps",
          filter: {
            type: "simple",
            placeholder: "Filtra temps",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Treballador",
          name: "trabajador",
          filter: {
            type: "simple",
            placeholder: "Filtra treballador",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Client",
          name: "client",
          filter: {
            type: "simple",
            placeholder: "Filtra client",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Projecte",
          name: "proyecto",
          filter: {
            type: "simple",
            placeholder: "Filtra projecte",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Accions",
          name: "acciones",
          row_text_alignment: "text-center",
        },
      ],
      classes: {
        cell: {
          "align-middle": true,
        },
      },
      config: {
        card_title: "Dedicacions",
        global_search: {
          placeholder: "Cerca",
        },
        per_page: 25,
        per_page_options: [25, 50, 100],
        num_of_visibile_pagination_buttons: 5,
      },
      nuevos: {
        dedicacion: {
          data_dedicacio: null,
          id_treballador: null,
          id_projecte: null,
          temps: null,
          observacions: null,
        },
      },
      clientes: [],
      proyectos: [],
      trabajadores: [],
      rango: null,
      cliente: "",
    };
  },
  computed: {
    maxFecha: function () {
      return new Date().toISOString().split("T")[0];
    },
    minFechaDate: function () {
      return new Date(new Date().setFullYear(new Date().getFullYear() - 1));
    },
    minFecha: function () {
      return this.minFechaDate.toISOString().split("T")[0];
    },
    rangoMax() {
      let date = new Date();

      date.setDate(date.getDate());

      return this.toDateISOString(date);
    },
  },
  created() {
    this.loading.clientes = true;

    this.$http.get("api/clients?order=titol")
      .then(response => this.clientes = response.data)
      .finally(() => this.loading.clientes = false);
  },
  methods: {
    toDateISOString(date) {
      return date.toISOString().split("T")[0];
    },
    getData(rango) {
      this.rango = rango;

      this.$http.get(`api/dedicacions?${new URLSearchParams({ fecha_inicio: rango.inicio, fecha_fin: rango.fin, id_client: this.cliente })}`)
        .then(response => {
          if (response.status == 200) {
            this.rows = response.data.map(row => ({
              ...row,
              data_dedicacio: row.data_dedicacio.split(" ")[0],
              data_dedicacio_format: this.formatearFecha(row.data_dedicacio),
              data_dedicacio_cell: `${row.data_dedicacio} ${this.formatearFecha(row.data_dedicacio)}`
            }));

            this.$toast.clear();
          }
        });

      this.$http.get("api/projectes?activos&order=cliente").then((response) => {
        this.proyectos = response.data;
      });

      this.$http.get("api/treballadors?activos&order=nom").then((response) => {
        this.trabajadores = response.data;
      });
    },
    getRowId(id, rows) {
      return rows.find((element) => {
        return element.id == id;
      });
    },
    getMinFecha(fecha) {
      return new Date(this.minFecha).getTime() <= new Date(fecha).getTime() ? this.minFecha : "";
    },
    crearMultiple() {
      this.loading.creacionMultiple = true;

      this.$http
        .post("api/dedicacions", this.nuevos.dedicacion)
        .then((response) => {
          this.loading.creacionMultiple = false;

          this.$nextTick(() => {
            if (response.status == 201) {
              this.cerrarCreacion();
              $(this.$refs.autofocusCreacionMultiple).trigger("focus");

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Dedicació creada correctament.` });

              if (this.rango?.inicio && response.data.data_dedicacio < this.rango.inicio) return;
              if (this.rango?.fin && response.data.data_dedicacio > this.rango.fin) return;

              this.rows.push({
                ...response.data,
                data_dedicacio_format: this.formatearFecha(response.data.data_dedicacio),
                data_dedicacio_cell: `${response.data.data_dedicacio} ${this.formatearFecha(response.data.data_dedicacio)}`
              });
            }
          });
        })
        .catch(() => {
          this.loading.creacionMultiple = false;
        });
    },
    editar(id) {
      this.loading.edicion = true;
      const fila = this.getRowId(id, this.rowsBuffer);

      this.$http
        .put(`api/dedicacions/${id}`, fila)
        .then((response) => {
          this.loading.edicion = false;

          this.$nextTick(() => {
            if (response.status == 200) {
              this.$refs[`modalEdicion${id}`].cerrar();
              this.getRowId(id, this.rowsBuffer).trabajador = response.data.trabajador;
              this.getRowId(id, this.rowsBuffer).proyecto = response.data.proyecto;
              this.getRowId(id, this.rowsBuffer).data_dedicacio_format = this.formatearFecha(response.data.data_dedicacio);
              this.getRowId(id, this.rowsBuffer).data_dedicacio_cell = `${response.data.data_dedicacio} ${this.formatearFecha(response.data.data_dedicacio)}`;

              if ((this.rango?.inicio && response.data.data_dedicacio < this.rango.inicio) || (this.rango?.fin && response.data.data_dedicacio > this.rango.fin)) {
                this.rows = this.rows.filter(row => row.id != id);
              } else {
                this.rows = structuredClone(this.rowsBuffer);
              }

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Dedicació editada correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.edicion = false;
        });
    },
    eliminar(id) {
      this.loading.eliminacion = true;

      this.$http
        .delete(`api/dedicacions/${id}`)
        .then((response) => {
          this.loading.eliminacion = false;

          this.$nextTick(function () {
            this.$refs[`modalEliminacion${id}`].cerrar();

            if (response.status == 200) {
              const found = this.rows.find((element) => element.id == id);
              found.eliminado = true;

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Dedicació eliminada correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.eliminacion = false;
        });
    },
    abrirModal(autofocus) {
      $(this.$refs[autofocus]).trigger("focus");
    },
    cerrarCreacion() {
      this.nuevos.dedicacion.data_dedicacio = null;
      this.nuevos.dedicacion.id_treballador = null;
      this.nuevos.dedicacion.id_projecte = null;
      this.nuevos.dedicacion.temps = null;
      this.nuevos.dedicacion.observacions = null;
    },
    cerrarEdicion() {
      this.rowsBuffer = structuredClone(this.rows);
    },
    cerrarEliminacion() {
      this.rows = this.rows.filter(function (item) {
        return item.eliminado != true;
      });
    },
    mostrarFecha(fecha) {
      return new Date(fecha).toLocaleDateString("ca-ES");
    },
    exportarTablaPrevio() {
      this.exportarTabla(this.$route.name, this.$refs.tabla);
    },
    exportarBolcatPrevio() {
      this.exportarBolcat(this.$route.name, this.$refs.tabla);
    },
  },
  watch: {
    rows(value) {
      this.rowsBuffer = structuredClone(value);
    },
  },
};
</script>